import { Body, Controller, Delete, Get, Param, Patch, Post, Query, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiOperation, ApiQuery, ApiTags } from '@nestjs/swagger';
import type { LoginUserInfo } from 'src/auth/dto/login.dto';
import { GetUser } from 'src/auth/get-user.decorator';
import { AgentesTransporteService } from './agentes-transporte.service';
import { CreateAgenteTransporteDto } from './dto/create-agente-transporte.dto';
import { UpdateAgenteTransporteDto } from './dto/update-agente-transporte.dto';

@ApiTags('Agentes de Transporte')
@ApiBearerAuth()
@UseGuards(AuthGuard('jwt'))
@Controller({ path: 'agentes-transporte', version: '1' })
export class AgentesTransporteController {
  constructor(private readonly service: AgentesTransporteService) {}

  @Post()
  @ApiOperation({ summary: 'Crear agente de transporte' })
  create(@Body() dto: CreateAgenteTransporteDto, @GetUser() user: LoginUserInfo) {
    return this.service.create(dto, user.empresa_id);
  }

  @Get('search')
  @ApiQuery({ name: 'q', required: true })
  @ApiQuery({ name: 'limit', required: false })
  search(@GetUser() user: LoginUserInfo, @Query('q') q: string, @Query('limit') limit?: string) {
    return this.service.search(user.empresa_id, q, Number(limit) || 20);
  }

  @Get()
  @ApiQuery({ name: 'page', required: false })
  @ApiQuery({ name: 'limit', required: false })
  @ApiQuery({ name: 'activo', required: false })
  findAll(
    @GetUser() user: LoginUserInfo,
    @Query('page') page?: string,
    @Query('limit') limit?: string,
    @Query('activo') activo?: string,
  ) {
    return this.service.findAll(
      user.empresa_id,
      Number(page) || 1,
      Number(limit) || 20,
      activo !== undefined ? activo === 'true' : undefined,
    );
  }

  @Get(':id')
  findOne(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.findOne(id, user.empresa_id);
  }

  @Patch(':id')
  update(@Param('id') id: string, @Body() dto: UpdateAgenteTransporteDto, @GetUser() user: LoginUserInfo) {
    return this.service.update(id, user.empresa_id, dto);
  }

  @Delete(':id')
  remove(@Param('id') id: string, @GetUser() user: LoginUserInfo) {
    return this.service.remove(id, user.empresa_id);
  }
}
